import auth from '~/auth';
import { removeTrackingToken } from '~/utils/tracking';
import { LOGIN_URL_SUFFIX } from '~/constants';

export const logout = () => {
	auth.removeToken();
	removeTrackingToken();
};

export const goToLoginPage = () => {
	const { language } = auth.getTokenData(auth.getToken());
	const lang = language || window.navigator.language.slice(0, 2);

	window.location.replace(
		['skoda.survio.com', 'stage-skoda.survio.com'].includes(location.host)
			? `${location.origin}/login`
			: `${window.env.HOME_URL}/${lang}/${LOGIN_URL_SUFFIX[lang]}`,
	);
};

export const logoutAndGoToLoginPage = () => {
	logout();
	goToLoginPage();
};
